/* eslint-disable */
import React from 'react';
import { Link } from 'react-router-dom';

function ReferBanner() {
    return (
        <>
            <div className="banner">
                <img
                    src='../../assets/images/Refer.jpg'
                    alt="Refer and Earn Banner"
                    title="Refer and Earn"
                    className="bannerImage"
                />
            </div>
        </>
    );
}

export default ReferBanner;
